import HomeStyle from "../styles&pics/HomeStyle"
import ServerAiStatus from "../UtilityComponents/ServerAiStatus";
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Separator } from "../ui/separator";
import { Download, ExternalLink, Megaphone, Sparkles } from "lucide-react";

const Home = () => {
  return (
    <>
      <HomeStyle />
      
      <main className="home-container">
        {/* Hero Section */}
        <Card className="hero-card">
          <CardHeader>
            <div className="hero-header">
              <CardTitle className="hero-title">
                <Sparkles className="hero-icon" />
                Καλώς ήρθατε!
              </CardTitle>
              <Badge variant="secondary" className="hero-badge">Online</Badge>
            </div>
          </CardHeader>
          <CardContent className="hero-content">
            <p className="hero-text">
              Αυτή είναι μια Online εφαρμογή για όποιον θέλει να εξασκηθεί στις ερωτήσεις 
              πιστοποίησης του ΕΟΠΠΕΠ για την ειδικότητα των πολυμέσων (ΙΕΚ).
            </p>
            <p className="hero-text">
              Για περισσότερες πληροφορίες δείτε{' '}
              <Link to="/info" className="hero-link">
                εδώ!
              </Link>
            </p>
          </CardContent>
        </Card>

        {/* Announcements Section */}
        <Card className="announcements-card">
          <CardHeader>
            <CardTitle className="announcements-title">
              <Megaphone className="announcements-icon" />
              Ανακοινώσεις
            </CardTitle>
            <CardDescription>Σημαντικές πληροφορίες και ενημερώσεις</CardDescription>
          </CardHeader>
          <CardContent className="announcements-content">
            <Alert className="announcement-alert">
              <AlertTitle>Σημείωση για Σχηματικές Ερωτήσεις</AlertTitle>
              <AlertDescription>
                Δεν λειτουργεί αλγόριθμος που κάνει έλεγχο εικόνας, οπότε δεν υπάρχει 
                βαθμολογία στα σχηματικά μέρη των απαντήσεων. Ευτυχώς είναι ελάχιστες!
              </AlertDescription>
            </Alert>

            <Separator className="announcement-separator" />

            <Alert className="announcement-alert">
              <AlertTitle>Σύστημα Βαθμολόγησης</AlertTitle>
              <AlertDescription>
                Η απάντηση του χρήστη όσο πιο όμοια είναι με το παρακάτω PDF τόσο 
                μεγαλύτερο βαθμό θα δίνει. Περισσότερες{' '}
                <Link to="/info" className="inline-link">πληροφορίες</Link> στον τομέα 
                version notes!
              </AlertDescription>
            </Alert>

            <Separator className="announcement-separator" />

            <div className="resources-section">
              <h3 className="resources-title">Χρήσιμοι Πόροι</h3>
              
              <Button 
                asChild 
                variant="outline" 
                className="resource-button"
              >
                <a 
                  href="https://exaskisi-iekmulty.helioho.st/ΤΕΧΝΙΚΟΣ_ΕΦΑΡΜΟΓΩΝ_ΠΛΗΡΟΦΟΡΙΚΗΣ_ΑΠΑΝΤΗΣΕΙΣ.pdf" 
                  download
                >
                  <Download className="button-icon" />
                  Ερωτήσεις και Απαντήσεις (PDF)
                </a>
              </Button>

              <p className="resources-note">
                Ψάχνοντας βρήκα και πιο σύγχρονες απαντήσεις στα ερωτήματα του ΕΟΠΠΕΠ 
                που δίνονται από το ΔΙΕΚ της ειδικότητας από την Αίγινα:
              </p>

              <div className="external-links">
                <Button 
                  asChild 
                  variant="outline" 
                  className="resource-button"
                >
                  <a 
                    href="https://2021diekaiginas.webnode.gr/antigrafi-apo-1-themata-apantiseis/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <ExternalLink className="button-icon" />
                    Βασικές Απαντήσεις
                  </a>
                </Button>

                <Button 
                  asChild 
                  variant="outline" 
                  className="resource-button"
                >
                  <a 
                    href="https://2021diekaiginas.webnode.gr/2-eidiko-meros-apantiseis-syndeseis/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <ExternalLink className="button-icon" />
                    Ειδικές Απαντήσεις
                  </a>
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Server Status */}
        <ServerAiStatus />
      </main>
    </>
  )
}

export default Home;
